/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import Vue from "@/entry/setupVue3.js"
import store from '../store'
import 'reflect-metadata'
import QwoachStorageManager from "@/core/js/backend/QwoachStorageManager";
import AuthManager from "@/core/js/backend/AuthManager";
import {isDevEnv} from "@/utils/helpers";
import dataManager from "@/entry/setupDataManager"
import PortalManager from "@/core/modules/PortalManager.js";
import {firebase, auth} from "@/core/js/backend/firebaseConfig";

let storageManager = new QwoachStorageManager(firebase, store)
let authManager = new AuthManager(auth, store, dataManager, storageManager)
let portalManager = new PortalManager({dataManager, store})

authManager.portalManager = portalManager
dataManager.portalManager = portalManager

Vue.config.globalProperties.$authManager = authManager
Vue.config.globalProperties.$dataManager = dataManager
Vue.config.globalProperties.$storageManager = storageManager
Vue.config.globalProperties.$portalManager = portalManager

if(isDevEnv){
	dataManager.isDebugEnabled = true
	storageManager.isDebugEnabled = true
}
